import MobileDevelopment from "../common/svg/MobileDevelopment";
import ITSolutions from "../common/svg/ITSolutions";
import ECommerce from "../common/svg/ECommerce";
import Shopify from "../common/svg/Shopify";
import WebDevelopment from "../common/svg/WebDevelopment";

export const SERVICE_DATA = [
  {
    id: "web-application-development",
    title: "Web Application Development",
    description:
      "We develop fast, modern, and scalable web applications that help businesses deliver seamless digital experiences.",
    img: "https://appthing-website.s3.ap-south-1.amazonaws.com/about-service-img.png",
    imgAlt: "Web Application Development",
    descImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-driscription-img-1.png",
    faqImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-faq-img-01.png",
    faqTitle: "FAQs about Web Application Development",
    delay: "200ms",
    icon: WebDevelopment,
    descriptionParagraphs: [
      "Our <strong>Web Application Development</strong> service focuses on building powerful, optimized, and user-centric web applications. We use modern technologies and clean architecture to ensure your application performs smoothly, loads quickly, and scales effortlessly as your business grows.",
      "From frontend frameworks like React and Next.js to backend technologies such as Node.js and MongoDB, we build robust end-to-end systems. Our team handles UI/UX design, API development, integrations, security, and long-term maintenance to ensure your web application stays future-ready.",
    ],
    faqs: [
      {
        id: 1,
        question: "Do you build custom web applications?",
        answer:
          "Yes, we create fully customized web applications based on your business requirements.",
      },
      {
        id: 2,
        question: "Are your applications mobile-responsive?",
        answer:
          "Yes, all our web applications are designed to work seamlessly across mobile, tablet, and desktop devices.",
      },
      {
        id: 3,
        question: "Can you integrate third-party services?",
        answer:
          "Absolutely. We integrate CRMs, payment gateways, analytics tools, and external APIs.",
      },
      {
        id: 4,
        question: "Do you provide long-term support?",
        answer:
          "Yes, we offer ongoing maintenance, updates, and security enhancements.",
      },
    ],
  },

  {
    id: "mobile-application-development",
    title: "Mobile Application Development",
    description:
      "We build intuitive, high-performance mobile applications that deliver smooth user experiences across Android and iOS.",
    img: "https://appthing-website.s3.ap-south-1.amazonaws.com/about-service-img.png",
    imgAlt: "Mobile Application Development",
    descImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-driscription-img-1.png",
    faqImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-faq-img-01.png",
    faqTitle: "FAQs about Mobile Application Development",
    delay: "300ms",
    icon: MobileDevelopment,
    descriptionParagraphs: [
      "Our <strong>Mobile Application Development</strong> service focuses on creating feature-rich and high-performing apps for both iOS and Android. We ensure your app delivers a seamless user experience, clean navigation, and reliable performance.",
      "Using modern tools like Flutter, React Native, Swift, and Kotlin, we build scalable mobile apps tailored to your goals. We also assist with API integration, push notifications, analytics, and app store deployment to ensure a smooth launch.",
    ],
    faqs: [
      {
        id: 1,
        question: "Do you build both Android and iOS apps?",
        answer:
          "Yes, we develop native and cross-platform apps for both major platforms.",
      },
      {
        id: 2,
        question: "Do you offer app store deployment support?",
        answer:
          "Yes, we help publish your app on the Play Store and App Store.",
      },
      {
        id: 3,
        question: "Can you integrate advanced features?",
        answer:
          "Yes. We integrate chat, maps, payments, analytics, and many other features.",
      },
      {
        id: 4,
        question: "Do you provide updates after launch?",
        answer:
          "Yes, we offer ongoing updates, bug fixes, and performance optimization.",
      },
    ],
  },

  {
    id: "it-staffing-solutions",
    title: "IT Staffing Solutions",
    description:
      "We help businesses hire skilled IT professionals through flexible, efficient, and reliable staffing models.",
    img: "https://appthing-website.s3.ap-south-1.amazonaws.com/about-service-img.png",
    imgAlt: "IT Staffing Solutions",
    descImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-driscription-img-1.png",
    faqImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-faq-img-01.png",
    faqTitle: "FAQs about IT Staffing Solutions",
    delay: "400ms",
    icon: ITSolutions,
    descriptionParagraphs: [
      "<strong>IT Staffing Solutions</strong> help companies quickly onboard skilled developers, designers, QA engineers, DevOps experts, and other technical professionals. We simplify talent acquisition by providing thoroughly vetted and highly qualified IT talent.",
      "Whether you need short-term contractors, long-term hires, or an entire remote team, we match you with the right talent. Our screening process ensures candidates meet your technical, cultural, and project expectations.",
    ],
    faqs: [
      {
        id: 1,
        question: "Do you provide remote IT professionals?",
        answer:
          "Yes, we offer on-site, hybrid, and fully remote staffing solutions.",
      },
      {
        id: 2,
        question: "How do you screen candidates?",
        answer:
          "We conduct technical tests, interviews, background checks, and skill evaluations.",
      },
      {
        id: 3,
        question: "Can you help with quick hiring?",
        answer:
          "Yes, we specialize in rapid talent deployment to meet urgent project needs.",
      },
      {
        id: 4,
        question: "Do you support long-term staffing?",
        answer:
          "Yes, we provide contract, contract-to-hire, and permanent placement services.",
      },
    ],
  },

  {
    id: "e-commerce-websites",
    title: "E-Commerce Websites",
    description:
      "We build powerful, high-converting eCommerce websites designed to boost sales, improve user experience, and grow your online brand.",
    img: "https://appthing-website.s3.ap-south-1.amazonaws.com/about-service-img.png",
    imgAlt: "E Commerce Websites",
    descImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-driscription-img-1.png",
    faqImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-faq-img-01.png",
    faqTitle: "FAQs about E-Commerce Websites",
    delay: "400ms",
    icon: ECommerce,
    descriptionParagraphs: [
      "<strong>E-Commerce Websites</strong> enable businesses to sell products online through fast, secure, and beautifully designed digital stores. We build customer-friendly interfaces that increase conversions and enhance the shopping experience.",
      "Our expertise includes product management, secure checkout systems, shipping integrations, analytics, and SEO optimization. We ensure your eCommerce store is scalable, mobile-friendly, and built for long-term growth.",
    ],
    faqs: [
      {
        id: 1,
        question: "Do you integrate payment gateways?",
        answer:
          "Yes, we integrate Stripe, Razorpay, PayPal, and other popular gateways.",
      },
      {
        id: 2,
        question: "Can you set up shipping integrations?",
        answer:
          "Yes, we support Shiprocket, Delhivery, BlueDart, and logistics APIs.",
      },
      {
        id: 3,
        question: "Do you offer product catalog management?",
        answer:
          "Yes, we handle product uploads, categories, variations, and inventory setup.",
      },
      {
        id: 4,
        question: "Is the website mobile responsive?",
        answer:
          "Yes, all our eCommerce websites are optimized for mobile users.",
      },
    ],
  },

  {
    id: "shopify-website-setup",
    title: "Shopify Website Setup",
    description:
      "We help businesses launch beautiful, fully customized Shopify stores optimized for conversions and brand growth.",
    img: "https://appthing-website.s3.ap-south-1.amazonaws.com/about-service-img.png",
    imgAlt: "Shopify Website Setup",
    descImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-driscription-img-1.png",
    faqImage:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/service-faq-img-01.png",
    faqTitle: "FAQs about Shopify Website Setup",
    delay: "300ms",
    icon: Shopify,
    descriptionParagraphs: [
      "<strong>Shopify Website Setup</strong> helps you build a professional, high-quality online store using Shopify’s powerful ecosystem. We handle everything from theme customization to product setup and payment configuration.",
      "We ensure your Shopify store is fast, mobile-responsive, SEO-optimized, and built to convert visitors into customers. Our team also integrates apps, marketing tools, and automation workflows for business growth.",
    ],
    faqs: [
      {
        id: 1,
        question: "Do you set up complete Shopify stores?",
        answer:
          "Yes, we handle product uploads, page setup, customizations, and integrations.",
      },
      {
        id: 2,
        question: "Can you customize Shopify themes?",
        answer:
          "Yes, we design and customize Shopify themes to match your brand identity.",
      },
      {
        id: 3,
        question: "Do you offer SEO improvements?",
        answer:
          "Yes, we optimize your store structure, metadata, URLs, and speed for better ranking.",
      },
      {
        id: 4,
        question: "Can you integrate Shopify apps?",
        answer:
          "Yes, we integrate marketing, CRM, analytics, subscription, and automation apps.",
      },
    ],
  },
];
